import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../blogs/admin_blog.css";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { useParams } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";

const updateTestimonialEndpoint = ApiEndpoints.VideoTestimonial.testimonialUpdate;
const testimonialEditEndpoint = ApiEndpoints.VideoTestimonial.testimonialEdit;

export default function EditTestimonial() {
  const {testimonial_id} = useParams()
  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [thumbnail, setThumbnail] = useState(null);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", `${testimonialEditEndpoint}${testimonial_id}` );
      const result = response.video_testimonial;
      setUrl(result.url)
      if(result.thumbnail){
        setThumbnail(result.thumbnail);
        setImagePreview(`${BaseUrl}${result.thumbnail}`);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleUrlChange = (e) => setUrl(e.target.value);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnail(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      setThumbnail(null);
      setImagePreview(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("url", url);
    formData.append("id", testimonial_id)
    // Append image files only if they are selected
    if (thumbnail) formData.append("thumbnail", thumbnail);

    try {
      await ApiRequest("POST", updateTestimonialEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      navigate("/admin/testimonial");
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Edit Testimonial</h5>
      </div>
      <div className="add-blog-content">
        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* url Input */}
            <div className="col-md-12">
              <label>Video URL (url of embedded link only):*</label>
              <input required type="text" value={url} onChange={handleUrlChange} className="form-control"/>
            </div>

            {/* Image Upload */}
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="thumbnail">Thumbnail (652 × 475 px)*</label>
                <input type="file" className="form-control" id="thumbnail" onChange={handleImageChange}/>
                {imagePreview && (
                  <img src={imagePreview} alt="Preview" style={{ width: "100px", maxHeight: "300px",marginTop:"8px" }} />
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                Edit Testimonial
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
